import { EnvironmentType } from 'src/environments/environment-type';

export class User {
	public Id?: number;
	public FirstName?: string;
	public LastName?: string;
	public FullName?: string;
	public ClientId?: string;
	public CurrentCompany?: Company;
	public CurrentProfileId?: number;
	public CurrentShopId?: number;
	public Email?: string;
	public IdCompany?: number;
	public IdPlatform?: number;
	public ImgPath?: string;
	public IsAuthenticated?: boolean;
	public LoggedInByMail?: boolean;
	public SSN?: string;
	public Sex?: string;
	public UserName?: string;
	public UserProfiles?: Array<UserProfile>;
	public SecurityStamp?: string;
	public Roles?: Array<string>;
	public UserType?: string;
}

export class UserProfile {
	public Id?: number;
	public IsCustom?: boolean;
	public IsDefault?: boolean;
	public LandingUrl?: string;
	public PlatformId?: number;
	public Title?: string;
	public Company?: Company;
	public ProfileName?: string;
}

export class Company {
	public Id?: number;
	public Name?: string;
	public IdCompanyLocation?: number;
	public BrowseId?: number;
	public CRSId?: number;
	public DisplayProfileName?: boolean;
	public GroupId?: number;
	public GroupDescription?: string;
	public LandingUrl?: string;
	public PlatformId?: number;
	public ShopId?: number;

	constructor(init?: Partial<Company>) {
		Object.assign(this, init);
	}


}

export class Header {
	public TopHeaderLogo?: TopHeaderLogo;
	public Dashboard?: Dashboard;
	public Navbar?: Navbar;
	public HasInbox?: boolean;
}

export class Page {
	public Id = -1;
	public ObjectTypeId = -1;
	public ObjectTypeName?: string;
	public ObjectId = -1;
	public ObjectName?: string;
	public DateId = -1;
	public DateStart?: Date;
	public DateEnd?: Date;
	public Components?: Array<any>;
	public HasInBox?: boolean;
	public IsMobileLayout = false;
	public NavBarAreaPickerItems?: AreaPickerMenuItem[];
	public Header?: Header;
}

export class Current {
	public User: User;
	public Page: Page;
	public SiteId: number;
	public SiteName: string;

	constructor() {
		this.Page = new Page();
		this.User = new User();
		this.SiteId = -1;
		this.SiteName = '';
	}
}

export class Dashboard {
	public Links?: MenuItem[];
}

export class MenuItem {
	public ParentMenuId?: number;
	public IsSelected?: boolean;
	public IsSelectable?: boolean;
	public Ord?: number;
	public Icon?: string;
	public Url?: string;
	public ItemStatusId?: number;
	public VersionId?: number;
	public MenuItems?: MenuItem[];
	public TargetBlank?: boolean;
	public ClientRouting?: boolean;
	public ShowSmallOnly?: boolean;
	public Id?: number;
	public Name?: string;
}

export class TopHeaderLogo {
	public TopHeaderImg?: string;
	public TopHeaderUrl?: string;
	public TopHeaderLabel?: string;
}

export class Navbar {
	public MenuItems?: MenuItem[];
	public SubMenu?: MenuItem[];
}

// tslint:disable-next-line:interface-name
export interface Path {
	Base?: string;
	Api?: string;
}

// tslint:disable-next-line:interface-name
export interface ApplicationPath {
	Local?: Path;
	Core?: Path;
	Global?: Path;
	Resources?: Path;
	BasicNet?: Path;
	BasicApp?: Path;
}

export class Settings {
	public AppPaths: ApplicationPath = {};
	public ImageNotFound?: string;
	public IsProduction?: boolean;
	public LocalVersion?: string;
	public LoginUrl?: string;
	public LogoffUrl?: string;
	public PickProfileUrl?: string;
	public RegisterUrl?: string;
	public Notifications?: { Messages: any[]; ProxySignalRUrl: '' };
	public Scheme?: string;
}

export class Context {
	public Current: Current;
	public Settings: Settings;
	public DefaultSiteId?: string;
	public Environment?: { type?: EnvironmentType; urlPart?: string; protocol?: string; deployPath?: string };

	constructor() {
		this.Current = new Current();
		this.Settings = new Settings();
	}
}

export class AreaPickerMenuItem {
	public SiteId?: number;
	public RouteName?: string;
	public DisplayName?: string;
	public ObjectId?: number;
	public ImgPath?: string;
}
